export type PriceType = 'net' | 'gross';

/** Fixed VAT rate applied to dedicated plan prices entered as net. */
export const VAT_RATE = 0.23;

export function toPriceType(value: string | null | undefined): PriceType {
  return value === 'gross' ? 'gross' : 'net';
}

export function grossFromNet(net: number) {
  return Math.round(net * (1 + VAT_RATE) * 100) / 100;
}

/** "149" / "183,27" — decimals only when the amount has grosze. */
export function formatAmount(amount: number) {
  const hasGrosze = !Number.isInteger(amount);

  return amount.toLocaleString('pl-PL', {
    minimumFractionDigits: hasGrosze ? 2 : 0,
    maximumFractionDigits: 2,
  });
}

/** "149 zł" / "183,27 zł" */
export function formatPln(amount: number) {
  return `${formatAmount(amount)} zł`;
}
